import type * as React from 'react';

export const CommonThumbnail = ({
  alt,
  ...rest
}: React.ImgHTMLAttributes<HTMLImageElement>): JSX.Element => {
  return <img {...rest} alt={alt} />;
};

export const getCommonThumbnail = (
  url: string,
  altText: string
): React.FunctionComponent => {
  return (
    props: Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'alt' | 'src'>
  ) => <CommonThumbnail {...props} src={url} alt={altText} />;
};
